export const BetTypeCalculationTypes = {
  Hi: 0,
  Colors: 1,
  ExactCard: 2,
  ExactCardWithColor: 3,
  MultiSelection: 4,
  Lo: 5,
};
